import { type SelectOption, TextField } from '@tryhackme/thm-ui-components';
import { StyledCompanyBarWrapper, StyledCompanyField, StyledDownload } from '../../corporate.styles';
import type { CompanyBarProps } from '../../corporate.types';
import { CreateCompanyModal } from '../create-company-modal/create-company-modal';
import { StyledCompanySearch, StyledCompanySelect, StyledCompanySize } from './compnay-bar.styles';
export const CompanyBar = ({
  options,
  selected,
  onChange
}: CompanyBarProps) => <StyledCompanyBarWrapper data-sentry-element="StyledCompanyBarWrapper" data-sentry-component="CompanyBar" data-sentry-source-file="company-bar.tsx">
    <StyledCompanySearch data-sentry-element="StyledCompanySearch" data-sentry-source-file="company-bar.tsx">
      <StyledCompanySelect data-sentry-element="StyledCompanySelect" data-sentry-source-file="company-bar.tsx">
        <StyledCompanySize data-sentry-element="StyledCompanySize" data-sentry-source-file="company-bar.tsx">Dashboard</StyledCompanySize>
        <StyledCompanyField data-sentry-element="StyledCompanyField" data-sentry-source-file="company-bar.tsx">
          <TextField isMulti={false} isSearchable variant="select" handleSelection={(value: SelectOption) => {
          onChange({
            id: value.id ?? '',
            value: value.value,
            label: value.label
          });
        }} options={options} selected={selected} defaultValue={selected} data-sentry-element="TextField" data-sentry-source-file="company-bar.tsx" />
        </StyledCompanyField>
      </StyledCompanySelect>
    </StyledCompanySearch>
    <StyledDownload data-sentry-element="StyledDownload" data-sentry-source-file="company-bar.tsx">
      <CreateCompanyModal onChange={onChange} data-sentry-element="CreateCompanyModal" data-sentry-source-file="company-bar.tsx" />
    </StyledDownload>
  </StyledCompanyBarWrapper>;